export const ACTION_LOAD_LAST_PAYOUT__REQUEST = 'ACTION_LOAD_LAST_PAYOUT__REQUEST';
export const ACTION_LOAD_LAST_PAYOUT__SUCCESS = 'ACTION_LOAD_LAST_PAYOUT__SUCCESS';
export const ACTION_LOAD_LAST_PAYOUT__FAIL = 'ACTION_LOAD_LAST_PAYOUT__FAIL';
